import { memberList } from '@/data';

export const memberState = () => ({
  currentMember: null,
});

export const actions = {
  getMember({ commit }: any, id: string) {
    try {
      const member = memberList.find((item: any) => item.id === id);
      commit('setMember', member);
    } catch (error) {
      console.log('error in getMember():', error);
    }
  },
  setCurrentMember({ commit }: any, member: any) {
    try {
      commit('setMember', member);
    } catch (error) {
      console.log('error in setCurrentMember():', error);
    }
  },
};

export const mutations = {
  setMember: (state: any, payload: any) => {
    state.currentMember = payload;
  },
};

export default {
  namespaced: true,
  state: memberState,
  actions,
  mutations,
};
